export default __webpack_public_path__ + "3b6647e.png";